module.exports = __webpack_public_path__ + "static/media/signage-indoor-img39.0b390b02.jpg";